import React, { useState } from 'react'
import PageHeader from '../components/PageHeader'
import { useText } from '../context/TextContext'
import { INTEGRATION_TABS, QUERY_PARAMS } from '../utils/shared/constants';
import CustomerFormTab from '../components/integrations/CustomerFormTab';
import AccountingTab from '../components/integrations/AccountingTab';
import useQueryParam from '../hooks/useQueryParams';
import { Tabs, Tab } from 'react-bootstrap';
import { useNavigate, useLocation } from 'react-router-dom';

export default function IntegrationsPage() {
    const text = useText();
    const { tab } = useQueryParam();
    const [activeTab, setActiveTab] = useState<INTEGRATION_TABS>(tab as INTEGRATION_TABS || INTEGRATION_TABS.CUSTOMER_FORM);
    const navigate = useNavigate();
    const location = useLocation();

    const handleTabSelect = (newTab: string | null) => {
        const selectedTab = newTab as INTEGRATION_TABS;
        setActiveTab(selectedTab);

        const params = new URLSearchParams(location.search);
        params.set(QUERY_PARAMS.TAB, selectedTab);
        navigate(`${location.pathname}?${params.toString()}`, { replace: true });
    };

    return (
        <div>
            <PageHeader title={text.integrations} description={text.integrationsDescription} showBackButton />

            <Tabs activeKey={activeTab} onSelect={handleTabSelect} className="mb-3">
                <Tab eventKey={INTEGRATION_TABS.CUSTOMER_FORM} title={text.customerForm}>
                    <CustomerFormTab />
                </Tab>
                <Tab eventKey={INTEGRATION_TABS.ACCOUNTING} title={text.accounting}>
                    <AccountingTab />
                </Tab>
            </Tabs>
        </div>
    )
}
